<template>
  <div class="answer">
    <div class="questionsBox">
        <div class="questions">
            {{details.webIntQaTitle}}
        </div>
        <div class="describe">
            {{details.webIntQaContent}}
        </div>
        <div class="answerReply">
            <!-- 图片列表展示 -->
            <div class="picture" v-if="details.webAttType == 4">
                <div class="onePicture" v-if="details.fileObjIds && details.fileObjIds.length==1">
                    <img :src="getimgUrl(details.fileObjIds[0])" alt="">
                </div>
                <div class="twoPicture" v-if="details.fileObjIds && details.fileObjIds.length==2">
                    <img :src="getimgUrl(details.fileObjIds[0])" alt="">
                    <img :src="getimgUrl(details.fileObjIds[1])" alt="">
                </div>
                <div class="morePicture" v-if="details.fileObjIds && details.fileObjIds.length>2">
                    <img :src="getimgUrl(details.fileObjIds[0])" alt="">
                    <div class="picRight">
                        <div class="top">
                            <img :src="getimgUrl(details.fileObjIds[1])" alt="">
                        </div>
                        <div class="bottom" style="position: relative;">
                            <img :src="getimgUrl(details.fileObjIds[2])" alt="">
                            <div style="width: 36px;height: 20px;position: absolute;bottom: 8px;right: 8px;background-color: rgba(0,0,0,.3);
                                 text-align: center;font-size: 12px;border-radius: 10px;color: #fff;">
                                {{details.fileObjIds.length}}图
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 视频展示 -->
            <div class="picture" v-if="details.webAttType == 2" style="position: relative;">
                <div class="onePicture">
                    <img :src="getimgUrl(details.fileObjIds[0])" alt="">
                </div>
                <div style="position: absolute; top: 50%;left: 50%;transform: translate(-50%,-50%);">
                    <img src="@/assets/questionsAndAnswer/playVideo.png" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="asnwerBox" >
        <van-list  v-model="loading" :finished="finished" finished-text="没有更多了"  >
            <van-cell >
                <div class="item" v-for="(item,index) in details.webInteractiveQaReplyEntityList" :key="index">
                    <div class="userMsg">
                        <img :src="item.createUserAvatar?getimgUrl(item.createUserAvatar):require('@/assets/questionsAndAnswer/user.png')" alt="" @click="jumpUserUrl(item.createUser)">
                        <div class="userName">
                            {{item.createUserName}}
                        </div>
                    </div>
                    <!-- 纯文本展示 -->
                    <div class="question" @click="jumpUrl(item.webIntQaRpyId)"> 
                        {{item.webIntQaRpyContent}}
                    </div>
                    <!-- 图片列表展示 -->
                    <div class="picture" v-if="item.webAttType == 4" @click="jumpUrl(item.webIntQaRpyId)">
                        <div class="onePicture" v-if="item.fileObjIds && item.fileObjIds.length==1">
                            <img :src="getimgUrl(item.fileObjIds[0])" alt="">
                        </div>
                        <div class="twoPicture" v-if=" item.fileObjIds && item.fileObjIds.length==2">
                            <img :src="getimgUrl(item.fileObjIds[0])" alt="">
                            <img :src="getimgUrl(item.fileObjIds[1])" alt="">
                        </div>
                        <div class="morePicture" v-if="item.fileObjIds && item.fileObjIds.length>2">
                            <img :src="getimgUrl(item.fileObjIds[0])" alt="">
                            <div class="picRight">
                                <div class="top">
                                    <img :src="getimgUrl(item.fileObjIds[1])" alt="">
                                </div>
                                <div class="bottom" style="position: relative;">
                                    <img :src="getimgUrl(item.fileObjIds[2])" alt="">
                                    <div style="width: 36px;height: 20px;position: absolute;bottom: 8px;right: 8px;background-color: rgba(0,0,0,.3);
                                            text-align: center;font-size: 12px;border-radius: 10px;color: #fff;">
                                            {{item.fileObjIds.length}}图
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 视频展示 -->
                    <div class="picture" v-if="item.webAttType == 2" style="position: relative;" @click="jumpUrl(item.webIntQaRpyId)"> 
                        <div class="onePicture">
                            <img :src="getimgUrl(item.fileObjIds[0])" alt="">
                        </div>
                        <div style="position: absolute; top: 50%;left: 50%;transform: translate(-50%,-50%);">
                            <img src="@/assets/questionsAndAnswer/playVideo.png" alt="">
                        </div>
                    </div>
                    <div class="footer">
                        <div class="createTime">
                            {{item.createTime}}
                        </div>
                    </div>
                </div>
            </van-cell>
        </van-list>
    </div>
  </div>
</template>

<script>
import { filePerviewPath } from "@/api/ActivitySolicitation/index.js";
import { interactiveqaDetail } from "@/api/questionsAndAnswer/index.js"
export default {
    data(){
        return{
            webIntQaId:"", // 问题id
            details:'', // 问题详情
            finished:true, // 触底加载底部显示
            loading:false, 
            pageNum:0,
        }
    },
    created(){
        let urlParams = new URLSearchParams(window.location.search)
        this.webIntQaId=urlParams.get('id')
        this.getDetailsItem()
    },
    mounted(){
        document.title="问答"
    },
    methods:{
        // 跳转到回复详情页
        jumpUrl(val){
            window.open('/answerDetails?id=' + val,'_self')
        },
        // 跳转用户详情
        jumpUserUrl(val){
            window.open('/userQuestionsAnswer?webUserId=' + val,'_self')
        },
        // 获取提问详情
        getDetailsItem(){
            this.pageNum++
            let params={
                pageNum:this.pageNum,
                pageSize:10,
                webIntQaId:this.webIntQaId,
                webAudStatus:1
            }
            interactiveqaDetail(params).then(res=>{
                if(res.data.code == 200){
                   this.details = res.data.data
                }else{
                    Toast(res.data.msg)
                }
            })
        },
        //获取图片
        getimgUrl(val) {
            return filePerviewPath({
                id: val,
                type: "cover"
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.answer{
    width: 100%;
    min-height: 100vh;
    background-color: #f3f3f3;
    .questionsBox{
        width: 100%;
        box-sizing: border-box;
        padding: 12px 16px;
        background-color: #fff;
        .questions{
            width: 100%;
            color: #333333;
            font-size: 16px;
            font-weight: bold;
        }
        .describe{
            margin-top: 12px;
            width: 100%;
            color: #666666;
            font-size: 14px;
        }
        .answerReply{
            width: 100%;
            margin-bottom: 20px;
            .picture{
                margin-top: 10px;
                width: 100%;
            }
            .onePicture{
                width: 100%;
                height: 190px;
            }
            .onePicture img{
                width: 100%;
                height: 100%;
                border-radius: 4px;
                object-fit: cover;
            }
            .twoPicture{
                width: 100%;
                height: 150px;
                display: flex;
                justify-content: space-between;
            }
            .twoPicture img{
                width: 48%;
                height: 100%;
                border-radius: 4px;
                object-fit: cover;
            }
            .morePicture{
                width: 100%;
                height: 163px;
                display: flex;
                justify-content: space-between;
            }
            .morePicture img{
                width: 48%;
                border-radius: 4px;
                object-fit: cover;
            }
            .picRight{
                width: 48%;
                height: 100%;
            }
            .picRight .top{
                width: 100%;
                height: 48%;
                margin-bottom: 11px;
            }
            .picRight .bottom{
                width: 100%;
                height: 48%;
            }
            .picRight .top img{
                width: 100%;
                height: 100%;
            }
            .picRight .bottom img{
                width: 100%;
                height: 100%;
            }
            .footer{
                width: 100%;
                height: 17px;
                line-height: 17px;
                margin-top: 12px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #999999;
                .createTime{
                    font-size: 14px;
                }
                .replyNum{
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    .replyPic{
                        width: 14px;
                        height: 14px;
                        margin-right:4px;
                        img{
                            width: 14px;
                            height: 14px;
                        }
                    }
                }
            }
        }
    }
    .asnwerBox{
        width: 100%;
        background-color: #fff;
        min-height: calc(100vh - 301px);
        box-sizing: border-box;
        margin-top: 5px;
        padding-top: 20px;
        .item{
            width: 100%;
            margin-bottom: 1px solid #F3F3F3;
            margin-bottom: 12px;
            .itemTitle{
                width: 100%;
                font-size: 16px;
                font-weight: bold;
                color: #333333;
            }
            .userMsg{
                display: flex;
                align-items: center;
                width: 100%;
                height: 36px;
                margin-bottom: 12px;
            }
            .userMsg img{
                width: 36px;
                height: 36px;
                border-radius: 50%;
                object-fit: cover;
            }
            .userName{
                margin-left: 7px;
                color: #000;
                font-size: 14px;
            }
            .question{
                width: 100%;
                font-size: 14px;
                color: #666;
                word-break: break-all;
            }
            .picture{
                margin-top: 10px;
                width: 100%;
            }
            .onePicture{
                width: 100%;
                height: 190px;
            }
            .onePicture img{
                width: 100%;
                height: 100%;
                border-radius: 4px;
            }
            .twoPicture{
                width: 100%;
                height: 150px;
                display: flex;
                justify-content: space-between;
            }
            .twoPicture img{
                width: 48%;
                height: 100%;
                border-radius: 4px;
            }
            .morePicture{
                width: 100%;
                height: 163px;
                display: flex;
                justify-content: space-between;
            }
            .morePicture img{
                width: 48%;
                border-radius: 4px;
            }
            .picRight{
                width: 48%;
                height: 100%;
            }
            .picRight .top{
                width: 100%;
                height: 48%;
                margin-bottom: 11px;
            }
            .picRight .bottom{
                width: 100%;
                height: 48%;
            }
            .picRight .top img{
                width: 100%;
                height: 100%;
            }
            .picRight .bottom img{
                width: 100%;
                height: 100%;
            }
            .footer{
                width: 100%;
                height: 17px;
                line-height: 17px;
                margin-top: 12px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #999999;
                .createTime{
                    font-size: 14px;
                }
                .replyNum{
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    .replyPic{
                        width: 14px;
                        height: 14px;
                        margin-right:4px;
                        img{
                            width: 14px;
                            height: 14px;
                        }
                    }
                }
            }
        }
    }
}
</style>